import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import HorseIcon from "components/Icons/Horse";
import LogoIcon from "components/Icons/SapLogo";
import HorseJockey from "components/Icons/HorseJockey";

import useStyles from "./styles";

interface IProps {
  facility: racehorse360.IFacility;
}

const TrackIcon = (props: IProps) => {
  const { facility } = props;

  const classes = useStyles({
    backgroundColor: facility.backgroundColor
  });

  const getFacilityIcon = (code: string) => {
    const iconsHash = {
      SA: <LogoIcon className={classes.facilityIcon} />,
      SLR: <HorseJockey className={classes.facilityIcon} />
    };

    if (!code || !iconsHash[code]) {
      return <HorseIcon className={classes.facilityIcon} />;
    }

    return iconsHash[code];
  };

  return (
    <>
      <div className={classes.iconContainer}>
        {getFacilityIcon(facility?.code)}
      </div>
    </>
  );
};

export default TrackIcon;
